export default {
  "Tabs": "_Tabs_sqece_1",
  "Tab": "_Tab_sqece_1"
};import "ni:sha-256;auO-HhABzw7KE291pKIUq3iRk2t42WSKcLux5RHZGm4";